import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";
import { isUndefined } from "lodash-es";

import { MARKETING_SETTINGS_ACTION_TYPE } from "./marketing-settings.action";
import { MARKETING_SETTINGS_ERROR_CODE } from "./marketing-settings.const";
import { MarketingSettingsState } from "./marketing-settings.model";

const INITIAL_STATE: MarketingSettingsState = {};

export function marketingSettingsReducer(state = INITIAL_STATE, action: ActionWithPayload): MarketingSettingsState {
	switch (action.type) {
		case MARKETING_SETTINGS_ACTION_TYPE.getConsentsSuccess:
		case MARKETING_SETTINGS_ACTION_TYPE.setDefaultConsents:
		case MARKETING_SETTINGS_ACTION_TYPE.updateCustomerConsentsSuccess: {
			return updateState(state, {
				consents: {
					...state.consents,
					...action.payload,
				},
				hasGivenConsents: undefined,
			});
		}
		case MARKETING_SETTINGS_ACTION_TYPE.updateMarketingSettingsSuccess:
		case MARKETING_SETTINGS_ACTION_TYPE.updateMarketingSettingsFromLoginFlowSuccess: {
			return updateState(state, {
				consents: {
					...state.consents,
					...action.payload.consents,
				},
			});
		}
		case MARKETING_SETTINGS_ACTION_TYPE.updateMarketingSettingsWithTokenSuccess: {
			return updateState(state, {
				hasGivenConsents: true,
				missingMarketingSettings: undefined,
			});
		}
		case MARKETING_SETTINGS_ACTION_TYPE.consentsNotAccepted: {
			return updateState(state, {
				hasGivenConsents: false,
				missingMarketingSettings: action.payload,
			});
		}
		case MARKETING_SETTINGS_ACTION_TYPE.getConsentsFail: {
			if (action.payload.code === MARKETING_SETTINGS_ERROR_CODE.getCustomerConsentsNotFound) {
				return updateState(state, {
					isConsentsNotFound: true,
				});
			}
			return state;
		}
		case MARKETING_SETTINGS_ACTION_TYPE.clearConsents: {
			if (!state.consents && !isUndefined(state.isConsentsNotFound)) {
				return state;
			}

			return updateState(state, {
				consents: undefined,
				isConsentsNotFound: undefined,
			});
		}
		case MARKETING_SETTINGS_ACTION_TYPE.setMissingMarketingSettingsDetails: {
			return updateState(state, {
				missingMarketingSettingsDetails: action.payload,
			});
		}
		case MARKETING_SETTINGS_ACTION_TYPE.clearMissingMarketingSettingsDetails: {
			return updateState(state, {
				missingMarketingSettingsDetails: undefined,
			});
		}
		case MARKETING_SETTINGS_ACTION_TYPE.clearMissingConsents: {
			if (!state.hasGivenConsents && !state.missingMarketingSettings) {
				return state;
			}

			return updateState(state, {
				hasGivenConsents: undefined,
				missingMarketingSettings: undefined,
			});
		}
		case MARKETING_SETTINGS_ACTION_TYPE.updateMarketingSettingsWithTokenFail: {
			return updateState(state, {
				error: {
					...action.payload,
				},
			});
		}
		default:
			return state;
	}
}
